export default __webpack_public_path__ + "static/media/07.9d26a342.jpg";